// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PhoneFilled: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 50.3"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M37.6 35.2c0-.1 0-.1 0 0-.1-.7-.5-1.3-1.2-1.7l-7.1-4.2s-.1 0-.1-.1c-.5-.2-.9-.2-1.4-.2-.7 0-1.4.3-2 .7l-2.1 2.1-.3-.1c-.2 0-.5-.1-1.2-.5-.5-.2-1.2-.6-2.1-1.2-.8-.6-1.8-1.5-2.9-2.6-1.1-1.1-2-2-2.6-2.9-.6-.8-1-1.5-1.3-2.1-.3-.6-.5-1.1-.6-1.5v-.1l1.8-1.8c.4-.4.7-.9.8-1.5.1-.6 0-1.2-.2-1.7l-3.9-7.5c-.2-.3-.5-.6-.8-.8-.4-.3-.8-.4-1.3-.4-.6 0-1.1.2-1.6.7l-4.9 4.9c-.3.3-.6.6-.8 1.1-.2.4-.3.8-.4 1.2v.8c0 .5 0 1.1.2 2 .1.8.4 1.8.7 2.9.4 1.1.9 2.3 1.6 3.7.7 1.3 1.6 2.8 2.8 4.4 1.1 1.6 2.6 3.2 4.3 4.9 2.2 2.2 4.3 4 6.2 5.3 1.9 1.3 3.7 2.2 5.3 2.9 1.6.6 2.9 1.1 4 1.2 1.1.2 1.9.2 2.4.2h.8c.4-.1.8-.2 1.2-.4.4-.2.8-.5 1-.7l4.9-4.9c.6-.7.9-1.4.8-2.1z"/></svg>;
};

export default React.memo(PhoneFilled);
